<template>
  <BaseImage v-bind="containerStyle"
             v-on="$listeners"
             :imageStyle="imageStyle"
             :src="src ? src : require('@img/user.svg')"
             @click="goToUserPage" />
</template>

<script>
  import BaseImage from '@base/base-image'

  export default {
    name: 'UserImage',
    inheritAttrs: false,
    components: {
      BaseImage,
    },
    props: {
      disabled: { type: Boolean, required: false, default: false },
      src: { type: String, required: false, default: '' },
      tenantUserId: { type: Number, required: false, default: -1 },
    },
    data: function () {
      return {
        containerStyle: {
          borderWidth: '1px',
          borderRadius: '50%',
        },
        cursor: this.tenantUserId > 0 ? 'pointer' : 'default',
        imageStyle: {
          objectFit: 'cover',
        },
        opacity: this.tenantUserId > 0 ? 0.5 : 1.0,
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        cursor: this.cursor,
        ...this.$attrs,
      };

      this.imageStyle = {
        ...this.imageStyle,
        filter: {
          '': 'none',
          hover: `opacity(${this.opacity})`,
          active: `opacity(${this.opacity})`,
        },
      };
    },
    methods: {
      goToUserPage: function () {
        if (this.tenantUserId > 0) {
          this.$router.push({ name: 'user', params: { id: this.tenantUserId }});
        }
      },
    },
  };
</script>
